export interface INetworkLoadStats {
  connectDuration: number;
  domainLookupDuration: number;
  sizeInKb: number;
  ttfb: number;
  url: string;
  downloadDuration: number;
  calculatedSpeed: number;
  type: 'text' | 'binary';
}

export const getNetworkStatsFromPerformance: (url: string, knownSize: number, mode: 'text' | 'binary') => INetworkLoadStats | null = (
  url,
  knownSize,
  mode,
) => {
  if (!globalThis.performance || !globalThis.performance.getEntriesByName) {
    return null;
  }

  const performanceEntry: PerformanceResourceTiming | undefined = globalThis.performance.getEntriesByName(
    url,
  )[0] as PerformanceResourceTiming;

  if (!performanceEntry) {
    return null;
  }

  const { connectStart, connectEnd, domainLookupEnd, duration, domainLookupStart, encodedBodySize, responseStart, requestStart } =
    performanceEntry;
  const size: number = (encodedBodySize || knownSize) / 1024;
  const downloadDuration: number = duration;

  globalThis.performance.clearResourceTimings();

  return {
    connectDuration: connectEnd - connectStart,
    domainLookupDuration: domainLookupEnd - domainLookupStart,
    sizeInKb: size,
    ttfb: responseStart - requestStart,
    downloadDuration: downloadDuration,
    calculatedSpeed: (size / (downloadDuration / 1000)) * 8,
    type: mode,
    url,
  };
};

export const getNetworkStats: (url: string, recordedDuration: number, knownSize: number, mode: 'text' | 'binary') => INetworkLoadStats = (
  url,
  recordedDuration,
  knownSize,
  mode,
) => {
  const statsFromPerformance: INetworkLoadStats | null = getNetworkStatsFromPerformance(url, knownSize, mode);

  return (
    statsFromPerformance || {
      connectDuration: 0,
      domainLookupDuration: 0,
      sizeInKb: knownSize / 1024,
      ttfb: 0,
      url,
      downloadDuration: recordedDuration,
      calculatedSpeed: (knownSize / 1024 / (recordedDuration / 1000)) * 8,
      type: mode,
    }
  );
};
